import { useState } from "react";
import api from "../api/client";
import { Input, Alert } from "../components/Ui";

const FAQ = [
  ["How long does a top-up take?", "Most orders land within a minute. If a provider is slow it can take up to 24 hours."],
  ["My order says \"review\".", "The provider didn't respond in time and we're confirming whether it went through. You won't be charged twice."],
  ["Only part of my order arrived.", "Some packs are fulfilled in several parts. Send us the order number and we'll finish it or refund the difference."],
  ["Can I get a refund?", "If an order fails outright, your wallet is refunded automatically. Anything else, ask us."],
];

export default function Support() {
  const [form, setForm] = useState({ name: "", email: "", mobile: "", msg: "" });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  async function submit(e) {
    e.preventDefault();
    setError(null);
    try {
      await api.post("/contact", form);
      setSent(true);
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="container" style={{ maxWidth: 680, padding: "32px 16px" }}>
      <h1 style={{ fontSize: 24 }}>Help center</h1>

      <div className="list" style={{ margin: "24px 0 48px" }}>
        {FAQ.map(([q, a]) => (
          <details key={q} style={{ padding: "12px 16px" }}>
            <summary style={{ cursor: "pointer", fontWeight: 700 }}>{q}</summary>
            <p className="muted small" style={{ marginBottom: 0 }}>{a}</p>
          </details>
        ))}
      </div>

      <h2 className="pi-label">Still stuck?</h2>
      {sent ? (
        <Alert tone="ok">Message sent. We'll reply by email.</Alert>
      ) : (
        <form onSubmit={submit} style={{ display: "grid", gap: 16 }}>
          <Input label="Name" required value={form.name} onChange={set("name")} />
          <Input label="Email" type="email" required value={form.email} onChange={set("email")} />
          <Input label="Mobile" required value={form.mobile} onChange={set("mobile")} />
          <label>
            <span className="muted small" style={{ display: "block", marginBottom: 6 }}>
              What's wrong? Include your order number.
            </span>
            <textarea className="input" rows={5} required maxLength={2000} value={form.msg} onChange={set("msg")} />
          </label>
          <Alert>{error}</Alert>
          <button className="btn primary">Send message</button>
        </form>
      )}
    </div>
  );
}
